import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../Student/Reusablecomponents/Loading";
import { useNavigate, useLocation } from "react-router-dom";
import {
  GetScenarioDetails,
  GetScienceQuestionDetails,
  GetEnglishQuestionDetails,
  GetQuestionDetails,
  GetEnglishScenarioDetails,
} from "../../ReusableComponents/CommonApis";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
const ProgressDrillDown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const WeekDetails = location.state?.PTDetaisl;

  const [PTDetails, SetPTDetails] = useState();
  const [Load, SetLoad] = useState(false);

  useEffect(() => {
    QuestionVerificationStatus();
  }, []);

  const QuestionVerificationStatus = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetWeeklyMappedQsByQBAdmin?QBCategoryCode=${location.state?.Tab}&SubjectID=${items?.subjectId}&WeekCol=${WeekDetails.week}&QBAdminId=${WeekDetails.qbAdminUserId}&GradeLovId=${WeekDetails.grade}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetPTDetails(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const PTColumns = [
    {
      name: "Question Verification Status",
      selector: "questionVerifyStatus",
      sortable: true,
    },
    ...(location.state?.Tab !== "DQ"
      ? [
          {
            name: "Scenario number",
            selector: "scenarioId",
            sortable: true,
            cell: (row) => (
              <div
                className="LinkStyles"
                onClick={() => NavigateScenario(row.scenarioId, true)}
              >
                {row.scenarioId ? row.scenarioId : ""}{" "}
              </div>
            ),
          },
        ]
      : []),
    {
      name: "Question Number",
      selector: "questionId",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          onClick={() => {
            if (location.state?.Tab !== "DQ" && row.scenarioId) {
              NavigateScenario(row.scenarioId, false, true);
              NavigateQuestion(row.questionId, false);
            } else {
              NavigateQuestion(row.questionId, true);
            }
          }}
        >
          {row.questionId}{" "}
        </div>
      ),
    },
  ];

  const NavigateQuestion = (QId, Scenario) => {
    switch (items?.subjectId) {
      case "1":
        GetQuestionDetails(
          SelectLanguage,
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
      case "2":
        GetScienceQuestionDetails(
          SelectLanguage,
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
      default:
        GetEnglishQuestionDetails(
          QId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario
        );
        break;
    }
  };

  const NavigateScenario = (SId, Scenario, Naviagtion) => {
    switch (true) {
      case ["3", "4", "5"].includes(items?.subjectId):
        GetEnglishScenarioDetails(
          SId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Scenario,
          Naviagtion
        );
        break;
      default:
        GetScenarioDetails(
          SelectLanguage,
          SId,
          dispatch,
          navigate,
          SetLoad,
          location,
          Naviagtion
        );
        break;
    }
  };
  return (
    <>
        <div className="MainHeading"> Questions</div>
      <div className="Card mt-2">
        {PTDetails ? (
          <DataTable
            data={PTDetails}
            columns={PTColumns}
            Dropdownvalues={["10", "20", "50", "100"]}
            className="NCLDataTable"
            ShowPagination="true"
            ShowPagecount="true"
          />
        ) : (
          <div className="NoData-Message">
            {process.env.REACT_APP_Nodata_Found}{" "}
          </div>
        )}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default ProgressDrillDown;
